export const emailRegx = /^[A-Za-z0-9._+-]+@([\w-]+\.)+[\w-]{2,4}$/;
